import type { Feature, Geometry } from 'geojson';
import { type TAPlan } from '../../TAPlan/TAPlan.types';
import { getTAPlanIcon } from '../../TAPlan/TAPlanUtils';
import { SvgIcon } from '../Extensions/SvgIcon';
import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import TAPlanTemplate from '../PopupTemplates/TAPlanTemplate';
import { TAPlanSource } from '../Sources/TAPlanSource';

export const taPlan = function (options?: ClusteredMarkerLayerOptions): ClusteredMarkerLayer {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: 'TA-plan',
        itemPlural: 'TA-planer',
        popupTemplate: TAPlanTemplate,
        source: new TAPlanSource({
            updateInterval: 60,
        }),
        customIcon: (feature: Feature<Geometry, TAPlan>) =>
            new SvgIcon({
                iconId: getTAPlanIcon(feature.properties.status),
                iconSize: [22, 22],
                popupAnchor: [0, -10],
            }),
        persistentInformationLayer: false,
        markerTitle: (featureProperties: TAPlan) => featureProperties.statusText,
    };

    return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
};
